import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  const { tr } = useLang();
  const n = tr("notfound");
  useSEO("notfound");
  return (
    <section data-testid="notfound-page" className="flex min-h-[80vh] items-center justify-center bg-navy px-6 pt-20">
      <div className="text-center">
        <p className="font-serif text-7xl italic text-gold-bright lg:text-8xl">404</p>
        <h1 className="mt-6 font-serif text-2xl text-ivory sm:text-3xl">{n.title}</h1>
        <p className="mx-auto mt-4 max-w-sm text-sm text-ivory/55">{n.sub}</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-10 inline-flex items-center gap-3 border border-gold/40 px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-gold-bright transition-colors hover:bg-gold/10"
        >
          <ArrowLeft className="h-4 w-4" /> {n.cta}
        </Link>
      </div>
    </section>
  );
}
